module.exports = __webpack_public_path__ + "img/7D.6c2bca96.png";